<page-grid [gridConfig]="submitToGrid"/>